
import { BasicDialogHandler } from "@goodgamestudios/core";
import { int } from "@goodgamestudios/math-utilities";

import { getLogger } from "@goodgamestudios/logger";

import { GameTypeAbstract } from "../../constants/gameTypes/GameTypeAbstract";
import { GameTypeMapper } from "../../constants/gameTypes/GameTypeMapper";
import { IGameTypeSpectator } from "../../constants/gameTypes/IGameTypeSpectator";
import { Constants } from "../../constants/shared/Constants";
import { Poker2TutorialController } from "../../controller/Poker2TutorialController";
import { Poker2OnTableEvent } from "../../event/Poker2OnTableEvent";
import { ChipsearnerVO } from "../../gamevo/ChipsearnerVO";
import { LobbyTablesVO } from "../../gamevo/LobbyTablesVO";
import { SeatVO } from "../../gamevo/SeatVO";
import { ShowdownCardsVO } from "../../gamevo/ShowdownCardsVO";
import { WinnerVO } from "../../gamevo/WinnerVO";
import { Poker2Model } from "../Poker2Model";
import { BasicData } from "./BasicData";

const logger = getLogger("JRBCommand");

export class Poker2onTableData extends BasicData {
    public buyIn: number = 0;
    public myPlayerPos: number = 0;
    public currentPlayerIndex: number = 0;
    public minimalRaiseCash: number = NaN;
    public actionWindowStates: Map<any, any>;
    public playerCards: any[];
    public playerActions: any[];
    public winnerList: WinnerVO[];
    public chipsearnerList: ChipsearnerVO[];

    public showdownCards: ShowdownCardsVO[];
    public showdownCommunitycards: any[] = [];
    public showdownWinner: WinnerVO[];
    public showdownChips: ChipsearnerVO[];
    public showdownPot: number = NaN;

    public currentTable: LobbyTablesVO;
    public isRunning: boolean = false;
    public playersSeatIndex: number[] = [];

    public static CARD_RANK: string[] = ["2", "3", "4", "5", "6", "7", "8", "9", "T", "J", "Q", "K", "A"];

    constructor() {
        super();
        this.myPlayerPos = -1;
        // testWinnerCards();
    }

    public parse_GPJ(paramObject: any): void {
        if (!paramObject)
            return;
        var index: number = int(paramObject.index);
        var seatParams: any[] = paramObject.seat;
        var seatVO: SeatVO = new SeatVO();
        seatVO.seated = parseInt(seatParams.shift()) == 1;
        seatVO.playerId = int(seatParams.shift());
        seatVO.userId = int(seatParams.shift());
        seatVO.tableChips = seatParams.shift();
        seatVO.handChips = seatParams.shift();
        seatVO.name = seatParams.shift();

        var avatarObject: any = seatParams.shift();
        seatVO.avatar = Poker2Model.avatarData.parseAvatar(avatarObject.gender, avatarObject.allowGiveChips, avatarObject.items);
        seatVO.level = int(seatParams.shift());
        seatVO.stateGame = int(seatParams.shift());
        seatVO.giftId = int(seatParams.shift());
        seatVO.zombie = int(seatParams.shift());
        this.controller.dispatchEvent(new Poker2OnTableEvent("playerJoin", [seatVO, index]));
    }

    public parse_GPL(paramObject: any): void {
        if (!paramObject)
            return;
        var removeSeatVO: SeatVO = this.getSeatVOByIndex(paramObject.index);

        this.removeSeat(paramObject.index);
        this.controller.dispatchEvent(new Poker2OnTableEvent("playerLeave", [paramObject.index, removeSeatVO, (paramObject.index == this.myPlayerPos)]));
        if (this.playersSeatIndex.length == 0)
            this.controller.dispatchEvent(new Poker2OnTableEvent("onEmptyTable"));
    }

    public parse_GSU(paramObject: any): void {
        if (!paramObject)
            return;
        if (paramObject.index >= 0)
            this.controller.dispatchEvent(new Poker2OnTableEvent("standUp", [paramObject.index]));
        if (this.playersSeatIndex.length == 0)
            this.controller.dispatchEvent(new Poker2OnTableEvent("onEmptyTable"));
    }

    public parse_GSI(paramObject: any): void {
        if (!paramObject)
            return;
        this.myPlayerPos = int(paramObject.index);

        var playerSeatVO: SeatVO = new SeatVO();
        playerSeatVO.seated = true;
        playerSeatVO.playerId = int(Poker2Model.userData.playerID);
        playerSeatVO.userId = int(Poker2Model.userData.userID);
        playerSeatVO.tableChips = 0;
        if (paramObject.buyIn)
            playerSeatVO.handChips = paramObject.buyIn;
        else
            playerSeatVO.handChips = this.buyIn;
        playerSeatVO.name = Poker2Model.userData.userName;
        playerSeatVO.avatar = Poker2Model.avatarData.myAvatar;
        playerSeatVO.level = int(Poker2Model.userData.userLevel);
        playerSeatVO.stateGame = int(8);
        playerSeatVO.giftId = int(paramObject.gift);
        this.addSeat(playerSeatVO, Poker2Model.onTableData.myPlayerPos);

        this.controller.dispatchEvent(new Poker2OnTableEvent("sitDown", [playerSeatVO]));
    }

    public parse_GLU(paramObject: any): void {
        this.controller.dispatchEvent(new Poker2OnTableEvent("playerLevelUp", [paramObject.index, paramObject.level]));
    }

    public parse_GPA(paramObject: any): void {
        if (!paramObject)
            return;
        this.playerCards = new Array();
        if (paramObject.c1)
            this.playerCards.push(paramObject.c1);
        if (paramObject.c2)
            this.playerCards.push(paramObject.c2);

        this.controller.dispatchEvent(new Poker2OnTableEvent("playercards"));
    }

    public parse_GAC(paramObject: any): void {
        if (!paramObject)
            return;
        this.playerActions = [paramObject.action, paramObject.tc, paramObject.hc, paramObject.index];
        this.controller.dispatchEvent(new Poker2OnTableEvent("playerAction"));
    }

    public parse_GST(paramObject: any): void {
        BasicDialogHandler.getInstance().blockDialogs = false;
        if (!paramObject || !this.currentTable)
            return;

        this.currentTable.communityCards = new Array();
        this.createPlayersList(paramObject.L);
        this.isRunning = true;
        this.controller.dispatchEvent(new Poker2OnTableEvent("startgame"));
    }

    public createPlayersList(paramArray: any[]): void {
        this.playersSeatIndex = [];
        if (paramArray) {
            for (var i: number = 0; i < paramArray.length; i++)
                this.playersSeatIndex.push(paramArray[i]);
        }
    }

    public parse_GSD(paramObject: any): void {
        if (!paramObject || !this.currentTable)
            return;
        this.currentTable.dealer = int(paramObject.index);
        this.controller.dispatchEvent(new Poker2OnTableEvent("changeDealer"));
    }

    public parse_GYT(paramObject: any): void {
        if (!paramObject) {
            return;
        }

        if (this.minimalRaiseCash < 0) {
            logger.error("parse_GYT() -> minimalRaiseCash lower than zero: " + this.minimalRaiseCash);
        }

        this.minimalRaiseCash = paramObject.chips;

        this.actionWindowStates = new Map<any, any>();

        for (let entryList of paramObject.aws) {
            var action: any = entryList;
            if (action === undefined) continue;
            this.actionWindowStates.set(action, "");
        }
        this.controller.dispatchEvent(new Poker2OnTableEvent("myplayerTurn"));
    }

    public parse_GPT(paramObject: any): void {
        if (!paramObject)
            return;
        this.currentPlayerIndex = int(paramObject.index);
        this.controller.dispatchEvent(new Poker2OnTableEvent("nextplayer"));
    }

    public parse_GGG(paramObject: any): void {
        if (paramObject)
            this.controller.dispatchEvent(new Poker2OnTableEvent("getGift", [paramObject.giftId, paramObject.fromIndex, paramObject.toIndex]));
    }

    private parseCommunityCards(paramArray: any[]): void {
        for (var i: number = 0; i < paramArray.length; i++) {
            // test, because of tutorial: back and forward give the same cards
            if (this.currentTable && this.currentTable.communityCards.indexOf(paramArray[i]) == -1)
                this.currentTable.communityCards.push(paramArray[i]);
        }
    }

    public parse_GNR(paramObject: any): void {
        if (!paramObject) {
            return;
        }

        this.controller.dispatchEvent(new Poker2OnTableEvent("nextRound", [paramObject.pot]));

        if (paramObject.C) {
            this.parseCommunityCards(paramObject.C);
            this.controller.dispatchEvent(new Poker2OnTableEvent("communitycards"));
        }
    }

    public parse_GEN(paramObject: any): void {
        BasicDialogHandler.getInstance().blockDialogs = true;
        if (paramObject) {
            this.showdownPot = paramObject.pot;
            this.parseShowdownCards(paramObject.K);
            this.parseShowdownCommunityCards(paramObject.C);
            this.parseCommunityCards(paramObject.C);
            this.parseShowdownWinner(paramObject.W);
            this.parseShowdownChips(paramObject.P);
        }
        this.isRunning = false;

        // Showdown animation starts
        if(Poker2Model.onTableData.currentTable) {
            Poker2Model.onTableData.currentTable.showdownAnimationInProgress = true;

            this.controller.dispatchEvent(new Poker2OnTableEvent("showdown"));
        }
    }

    /**
     * Play rabbit cam.
     * @param paramObject
     */
    public parse_GRP(paramObject: any): void {
        if (paramObject) {
            this.parseShowdownCommunityCards(paramObject.C);
            this.parseCommunityCards(paramObject.C);
        }

        //
        this.controller.dispatchEvent(new Poker2OnTableEvent("playRabbitCam"));
    }

    public parse_GBS(paramObject: any): void {
        if (!paramObject)
            return;
        this.controller.dispatchEvent(new Poker2OnTableEvent("bookSeat", [paramObject.seatId, paramObject.bookTime, paramObject.type]));
    }

    public parse_GBO(paramObject: any): void {
        if (!paramObject)
            return;
        this.addBookedSeat(paramObject.seatId);
        this.controller.dispatchEvent(new Poker2OnTableEvent("bookedSeat", [paramObject.seatId]));
    }

    public parse_GBR(paramObject: any): void {
        if (!paramObject)
            return;
        this.removeBookedSeat(paramObject.seatId);
        this.controller.dispatchEvent(new Poker2OnTableEvent("bookReleased", [paramObject.seatId]));
    }

    private parseShowdownCommunityCards(paramArray: any[]): void {
        this.showdownCommunitycards = new Array();
        for (var i: number = 0; i < paramArray.length; i++) {
            this.showdownCommunitycards.push(paramArray[i]);
        }
    }

    private parseShowdownCards(paramArray: any[]): void {
        this.showdownCards = [];
        if (paramArray != null) {
            for (let entryList of paramArray) {
                var cardsLine: any = entryList;
                if (cardsLine === undefined) continue;

                var cardsVO: ShowdownCardsVO = new ShowdownCardsVO();
                cardsVO.index = int(cardsLine.shift());
                cardsVO.c1 = cardsLine.shift();
                cardsVO.c2 = cardsLine.shift();
                this.showdownCards.push(cardsVO);
            }
        }
    }

    public getShowdownCardsByIndex(index: number): ShowdownCardsVO {
        if (this.showdownCards != null) {
            for (let entryList of this.showdownCards) {
                var cards: any = entryList;
                if (cards === undefined) continue;

                if (index == cards.index) {
                    return cards;
                }

            }
        }
        return null;
    }

    private parseShowdownWinner(paramArray: any[]): void {
        this.showdownWinner = [];
        if (paramArray != null) {
            for (let entryList of paramArray) {
                var winnerLine: any = entryList;
                if (winnerLine === undefined) continue;

                var winnerVO: WinnerVO = new WinnerVO();
                winnerVO.index = int(winnerLine.shift());
                winnerVO.handcategory = int(winnerLine.shift());
                if (this.getShowdownCardsByIndex(winnerVO.index)) {
                    winnerVO.c1 = this.getShowdownCardsByIndex(winnerVO.index).c1;
                    winnerVO.c2 = this.getShowdownCardsByIndex(winnerVO.index).c2;
                }
                //				winnerVO.chips = winnerLine.shift();
                this.showdownWinner.push(winnerVO);
            }
        }
    }
    private parseShowdownChips(paramArray: any[]): void {
        this.showdownChips = [];
        if (paramArray != null) {
            for (let entryList of paramArray) {
                var chipsearnerLine: any = entryList;
                if (chipsearnerLine === undefined) continue;

                var chipsEarnerVO: ChipsearnerVO = new ChipsearnerVO();
                chipsEarnerVO.index = int(chipsearnerLine.shift());
                chipsEarnerVO.chips = chipsearnerLine.shift();
                this.showdownChips.push(chipsEarnerVO);
            }
        }
    }

    public parse_GHC(paramObject: any): void {
        if (paramObject)
            this.controller.dispatchEvent(new Poker2OnTableEvent("handcategory", [paramObject.hc]));
    }

    public parse_TJN(paramObject: any): void {
        this.buildLobbyTableVOsAndSeatVOs(paramObject, GameTypeMapper.mapTableType(paramObject.type));
    }

    public buildLobbyTableVOsAndSeatVOs(paramObject: any, gameType: GameTypeAbstract): void {
        if (!paramObject) {
            return;
        }

        if (instanceOfClass(gameType, "DefaultTableTypeAbstract")) {
            if (paramObject.PN) {
                // Tischdaten noch nicht bekannt (bei sofortspielen)
                var tabelData: any[] = paramObject.PN;
                this.currentTable = new LobbyTablesVO();
                this.currentTable.id = paramObject.id;
                this.currentTable.name = tabelData[0];
                this.currentTable.sBlind = int(tabelData[1]);
                this.currentTable.players = int(tabelData[2]);
                this.currentTable.specs = int(tabelData[3]);
                this.currentTable.help = tabelData[4];
            }
            else {
                this.currentTable = Poker2Model.lobbyData.getLobbyTableById(paramObject.id);
                //						currentTable.sub_type = paramObject.type;
                //sb SmallBlind
                this.currentTable.sBlind = int(paramObject.sb);
            }
            var bookedSeats: any[] = paramObject.B;
            if (bookedSeats) {
                this.currentTable.bookedSeats = bookedSeats;
            }
        }
        else if (instanceOfClass(gameType, "TournamentTypeAbstract")) {
            this.currentTable = Poker2Model.tournamentData.currentTournamentTable;

            if (!((<IGameTypeSpectator>gameType).isGameTypeSpectator)) {
                // PLAYER
                this.currentTable.tournamentInProgress = true;
            }
            else {
                // SPECTATOR
                this.currentTable.id = paramObject.id;

                // TODO: Read the specific table name (differs the tournaments name which will be showed as player)
                // Maybe taking this name as player fixes bug 1117 (if this is a bug)
                if (Poker2Model.tournamentData.getLobbyTableById(paramObject.id)) {
                    this.currentTable.name = Poker2Model.tournamentData.getLobbyTableById(paramObject.id).tableName;
                }
            }
        }
        else if (instanceOfClass(gameType, "SitngoTypeAbstract")) {
            this.currentTable = Poker2Model.onSitnGoData.currentSitnGoTable;

            if (!((<IGameTypeSpectator>gameType).isGameTypeSpectator)) {
                // PLAYER
                this.currentTable.tournamentInProgress = true;
                this.currentTable.name = paramObject.name;
            }
            else {
                // SPECTATOR

                this.currentTable.name = paramObject.name;
            }
        }

        // general values, needed for every table
        this.currentTable.gameType = gameType;
        // skinId not implemented yet for the server. Will be done in upcoming refactoring sprints
        this.currentTable.skinId = int(paramObject.skinId);
        this.currentTable.actionTime = int(paramObject.aTime);
        this.currentTable.communityCards = paramObject.C;
        this.currentTable.dealer = int(paramObject.dealer);
        this.currentTable.pot = paramObject.pot;
        this.currentTable.giftMultiplicator = int(paramObject.gm);
        this.currentTable.playerTurn = int(paramObject.turn);

        //Hier wird geprüft ob ein spiel bereits läuft, wenn man einem Tisch joint
        this.isRunning = (this.currentTable.playerTurn != -1);

        // parse seats array and create seat vos
        this.buildSeatVOs(paramObject.S);

        antiCheating.table = this.currentTable.id + "_" + this.currentTable.name;
        antiCheating.lockTable();

        //
        this.controller.dispatchEvent(new Poker2OnTableEvent("changeCurrentTableData"));
    }

    private getPlayerName(name: string): string {
        if (Poker2TutorialController.getInstance().isActive) {
            switch (name) {
                case "Timo":

                    name = Poker2Model.languageData.getTextById("tut_player1");
                    break;

                case "Oliver":

                    name = Poker2Model.languageData.getTextById("tut_player2");
                    break;

                case "Alina":

                    name = Poker2Model.languageData.getTextById("tut_player3");
                    break;
            }
        }

        return name;
    }

    private buildSeatVOs(seats: any[]): void {
        var seatParams: any[] = seats;
        this.playersSeatIndex = new Array();
        this.myPlayerPos = -1;
        if (seatParams != null) {
            for (var i: number = 0; i < seatParams.length; i++) {
                var seatLine: any[] = seatParams[i];
                var seatVO: SeatVO = new SeatVO();
                seatVO.seated = parseInt(seatLine.shift()) == 1;
                if (seatVO.seated) {
                    seatVO.playerId = int(seatLine.shift());
                    if (seatVO.playerId == Poker2Model.userData.playerID)
                        this.myPlayerPos = i;

                    seatVO.userId = int(seatLine.shift());
                    seatVO.tableChips = seatLine.shift();
                    seatVO.handChips = seatLine.shift();
                    seatVO.name = this.getPlayerName(seatLine.shift());
                    var avatarObject: any = seatLine.shift();
                    seatVO.avatar = Poker2Model.avatarData.parseAvatar(avatarObject.gender, avatarObject.allowGiveChips, avatarObject.items);
                    seatVO.level = int(seatLine.shift());
                    seatVO.stateGame = int(seatLine.shift());
                    seatVO.giftId = int(seatLine.shift());
                    seatVO.zombie = int(seatLine.shift());

                    this.playersSeatIndex.push(i);
                }
                this.addSeat(seatVO, i);
            }
        }
    }

    public get communityCards(): any[] {
        return (this.currentTable) ? this.currentTable.communityCards : [];
    }

    public addSeat(seatVO: SeatVO, index: number): void {
        if(this.currentTable) {
            this.currentTable.seats[index] = seatVO;
        }
    }
    // Ist eher eine Update funktion, kein echtes entfernen des VOs
    public removeSeat(index: number): void {
        if(this.currentTable) {
            this.currentTable.seats[index].seated = false;
        }
        this.removeSeatIndex(index);
    }

    public addBookedSeat(index: number): void {
        if(this.currentTable) {
            this.currentTable.bookedSeats.push(index);
        }
    }

    private removeSeatIndex(index: number): void {
        for (var i: number = 0; i < this.playersSeatIndex.length; i++) {
            if (this.playersSeatIndex[i] == index)
                this.playersSeatIndex.splice(i, 1);
        }
    }

    private removeBookedSeat(index: number): void {
        if(!this.currentTable) {
            return;
        }

        for (var i: number = 0; i < this.currentTable.bookedSeats.length; i++) {
            if (this.currentTable.bookedSeats[i] == index)
                this.currentTable.bookedSeats.splice(i, 1);
        }
    }

    public getSeatIndexByPlayerId(playerId: number): number {
        if (this.currentTable)
            for (var index: number = 0; index < this.currentTable.seats.length; index++) {
                var seatVO: SeatVO = this.currentTable.seats[index];
                if (seatVO && seatVO.playerId == playerId)
                    return index;
            }
        return 0;
    }

    public getSeatVOByIndex(index: number): SeatVO {
        if (this.currentTable == null || index < 0 || index >= this.currentTable.seats.length)
            return null;

        return this.currentTable.seats[index];
    }

    private parseWinnerList(paramArray: any[]): void {
        this.winnerList = [];
        if (paramArray != null) {
            for (let entryList of paramArray) {
                var winnerLine: any = entryList;
                if (winnerLine === undefined) continue;

                var winnerVO: WinnerVO = new WinnerVO();
                winnerVO.index = int(winnerLine.shift());
                winnerVO.c1 = winnerLine.shift();
                winnerVO.c2 = winnerLine.shift();
                winnerVO.chips = winnerLine.shift();
                winnerVO.handcategory = int(winnerLine.shift());
                this.winnerList.push(winnerVO);
            }
        }
    }
    private parseChipsEarnerList(paramArray: any[]): void {
        this.chipsearnerList = [];
        if (paramArray != null) {
            for (let entryList of paramArray) {
                var chipsearnerLine: any = entryList;
                if (chipsearnerLine === undefined) continue;

                var chipsEarnerVO: ChipsearnerVO = new ChipsearnerVO();
                chipsEarnerVO.index = int(chipsearnerLine.shift());
                chipsEarnerVO.chips = chipsearnerLine.shift();
                this.chipsearnerList.push(chipsEarnerVO);
            }
        }
    }

    /**
     * Funktionen zur Berechnung der Gewinnerkarten
     * getHighestCards - sortiert Spielerkarten und a.W. Communitykarten absteigend
     * getHighestPair - gibt die höchsten Paarkarten zurück
     * getHighestFlush - gibt das höchste Flush zurück
     * getHighestStraight - gibt die höchste Straße zurück
     * highlightWinnerCards - gibt ein Array mit den zu Highlightenden Karten zurück, je nach Handkategorie werden die Gewinnerkarten ermittelt
     */
    public getHighestCards(card1: string, card2: string, useCommunityCards: boolean = false, ownCommunityCards: any[] = null): any[] {
        var result: any[] = [card1, card2];
        if (!useCommunityCards)
            return result.sort(this.bindFunction(this.sortByCardRank));

        var i: number = 0;
        if (ownCommunityCards)
            for (i; i < ownCommunityCards.length; i++)
                result.push(ownCommunityCards[i]);
        else {
            if (this.currentTable)
                for (i; i < this.currentTable.communityCards.length; i++)
                    result.push(this.currentTable.communityCards[i]);
        }
        return result.sort(this.bindFunction(this.sortByCardRank));
    }

    public getHighestPair(card1: string, card2: string, withoutCards: any[], ownCommunityCards: any[], numOfPair: number = 2): any[] {
        var result: any[] = new Array();
        var highCards: any[] = this.getHighestCards(card1, card2, true, ownCommunityCards);
        var numOfEqual: number = 0;
        var equal: boolean = false;
        for (var i: number = 0; i < highCards.length; i++) {
            if (withoutCards.indexOf(highCards[i]) >= 0)
                continue;

            numOfEqual = 1;
            equal = true;
            while (equal && numOfEqual + i < highCards.length) {
                equal = (String(highCards[i]).charAt(0) == String(highCards[i + numOfEqual]).charAt(0));
                if (equal)
                    numOfEqual++;
            }
            if (numOfEqual >= numOfPair) {
                for (var j: number = 0; j < numOfEqual; j++)
                    result.push(highCards[i + j]);
                return result;
            }
        }
        return result;
    }

    public getHighestFlush(card1: string, card2: string, ownCommunityCards: any[]): any[] {
        var currentPair: any[] = new Array();
        var cards: any[] = this.getHighestCards(card1, card2, true, ownCommunityCards);

        for (var i: number = 0; i < cards.length - 1; i++) {
            currentPair = new Array();
            for (var j: number = i; j < cards.length; j++) {
                // prüft auch mit sich selbst!
                if (i == j || cards[i].charAt(1) == cards[j].charAt(1))
                    currentPair.push(cards[j]);
                if (currentPair.length >= 5)
                    break;
            }
            if (currentPair.length >= 5)
                break;
        }
        return currentPair;
    }

    public getHighestStraight(card1: string, card2: string, ownCommunityCards: any[], flush: boolean = false): any[] {
        var result: any[] = new Array();
        var highCards: any[] = this.getHighestCards(card1, card2, true, ownCommunityCards);
        var sortedCards: any[] = this.removeEqualCards(highCards);
        var resultAry: any[] = [];
        var last: number = 0;

        // as after 2
        if (sortedCards[0].charAt(0) == "A" && sortedCards[sortedCards.length - 1].charAt(0) == "2") {
            sortedCards.push(sortedCards[0]);
        }

        for (var i: number = 0; i < sortedCards.length - 4; i++) {
            if (sortedCards[i + 4].charAt(0) == "A") {
                last = 4 - 1; // "2" is index 0
            }
            else {
                last = int(4 + Poker2onTableData.CARD_RANK.indexOf(sortedCards[i + 4].charAt(0)));
            }
            if (Poker2onTableData.CARD_RANK.indexOf(sortedCards[i].charAt(0)) == last) {
                for (var b: number = i; b < i + 5; b++) {
                    if (b < sortedCards.length)
                        result.push(sortedCards[b]);
                }
                return result;
            }
        }
        return result;
    }

    public getHighestStraightFlush(card1: string, card2: string, ownCommunityCards: any[]): any[] {
        const numOfPair: number = 5;
        const color: string = 'dsch';
        var result: any[];
        var cards: any[] = this.getHighestCards(card1, card2, true, ownCommunityCards);

        for (var i: number = 0; i < 4; i++) {
            result = [];
            for (var j: number = 0; j < cards.length; j++) {
                if (cards[j].charAt(1) == color.charAt(i)) {
                    result.push(cards[j]);
                }
            }
            if (result.length >= numOfPair) {
                // as after 2
                if (cards[0].charAt(0) == "A" && cards[4].charAt(0) == "2") {
                    result.push(result.shift());
                }
                return result.slice(0, 5);
            }
        }
        return [];
    }

    /**
     * Löscht doppelte Karten (nach wertigkeit)
     */
    public removeEqualCards(cards: any[]): any[] {
        var i: number = -1;
        var ln: number = cards.length - 1;
        while ((++i < ln)) {
            var j: number = i + 1;
            do {
                if (cards[j] && cards[i] && Poker2onTableData.CARD_RANK.indexOf(cards[j].charAt(0)) == Poker2onTableData.CARD_RANK.indexOf(cards[i].charAt(0))) {
                    cards.splice(j, 1);
                    ln--;
                    j--;
                }
            }
            while (j++ < ln - 1);
        }
        return cards;
    }

    public sortByCardRank(x: string, y: string): number {
        if (Poker2onTableData.CARD_RANK.indexOf(x.charAt(0)) > Poker2onTableData.CARD_RANK.indexOf(y.charAt(0))) return -1;
        if (Poker2onTableData.CARD_RANK.indexOf(y.charAt(0)) > Poker2onTableData.CARD_RANK.indexOf(x.charAt(0))) return 1;
        return 0;
    }

    /**
     * for test only
    private function testWinnerCards():void
    {
        var ownCommunityCards:Array;
        var winner:WinnerVO = new WinnerVO();

        // /cards 3c 4c Ks Jd Kd 9h As Jh Kc
        winner.handcategory = 6;
        winner.c1 = 'Ks';
        winner.c2 = 'Jd';
        ownCommunityCards = ['Kd','9h','As','Jh','Kc'];
        trace("##test## highlightWinnerCards FULLHOUSE:",highlightWinnerCards(winner, ownCommunityCards));

        //  /cards 3c 4c Ks Jd 2d 3s 4c 5d 6d
        winner.handcategory = 4;
        winner.c1 = 'Ks';
        winner.c2 = 'Jd';
        ownCommunityCards = ['2d','3s','4c','5d','Ad'];
        trace("##test## highlightWinnerCards STRAIGHT:",highlightWinnerCards(winner, ownCommunityCards));

        //  /cards 3c 4c Ks Jd 2d 3d 4d 5d 6d
        winner.handcategory = 8;
        winner.c1 = 'Ks';
        winner.c2 = 'Jd';
        ownCommunityCards = ['2d','3d','5d','6d','7d'];
        trace("##test## highlightWinnerCards STRAIGHTFLUSH:",highlightWinnerCards(winner, ownCommunityCards));

        //  /cards 3c 4c Ks Jd 2d 3d 4d 5d Ad
        winner.handcategory = 8;
        winner.c1 = 'Ks';
        winner.c2 = 'Jd';
        ownCommunityCards = ['2d','3d','4d','5d','Ad'];
        trace("##test## highlightWinnerCards STRAIGHTFLUSH:",highlightWinnerCards(winner, ownCommunityCards));
    }
     */

    public highlightWinnerCards(winner: WinnerVO, ownCommunityCards: any[] = null): any[] {
        var winnCards: any[] = new Array();
        switch (winner.handcategory) {
            case 0:
                var highcards: any[] = this.getHighestCards(winner.c1, winner.c2, true, ownCommunityCards);
                winnCards.push(highcards[0]);
                break;
            case 1:
                var highpair: any[] = this.getHighestPair(winner.c1, winner.c2, [], ownCommunityCards);
                winnCards.push(highpair[0], highpair[1]);
                break;
            case 2:
                var firstHighpair: any[] = this.getHighestPair(winner.c1, winner.c2, [], ownCommunityCards);
                var secondHighpair: any[] = this.getHighestPair(winner.c1, winner.c2, firstHighpair, ownCommunityCards);
                winnCards.push(firstHighpair[0], firstHighpair[1], secondHighpair[0], secondHighpair[1]);
                break;
            case 3:
                var highthree: any[] = this.getHighestPair(winner.c1, winner.c2, [], ownCommunityCards, 3);
                winnCards.push(highthree[0], highthree[1], highthree[2]);
                break;
            case 7:
                var highfour: any[] = this.getHighestPair(winner.c1, winner.c2, [], ownCommunityCards, 4);
                winnCards.push(highfour[0], highfour[1], highfour[2], highfour[3]);
                break;
            case 6:
                var threepair: any[] = this.getHighestPair(winner.c1, winner.c2, [], ownCommunityCards, 3);
                var twopair: any[] = this.getHighestPair(winner.c1, winner.c2, threepair, ownCommunityCards);
                winnCards.push(threepair[0], threepair[1], threepair[2], twopair[0], twopair[1]);
                break;
            case 5:
                var flush: any[] = this.getHighestFlush(winner.c1, winner.c2, ownCommunityCards);
                winnCards.push(flush[0], flush[1], flush[2], flush[3], flush[4]);
                break;
            case 4:
                var straight: any[] = this.getHighestStraight(winner.c1, winner.c2, ownCommunityCards);
                winnCards.push(straight[0], straight[1], straight[2], straight[3], straight[4]);
                break;
            case 8:
                var straightflush: any[] = this.getHighestStraightFlush(winner.c1, winner.c2, ownCommunityCards);
                winnCards.push(straightflush[0], straightflush[1], straightflush[2], straightflush[3], straightflush[4]);
                break;
            case 9:
                var royal: any[] = this.getHighestFlush(winner.c1, winner.c2, ownCommunityCards);
                winnCards.push(royal[0], royal[1], royal[2], royal[3], royal[4]);
                break;
        }
        return winnCards;
    }
}

import { instanceOfClass } from "@goodgamestudios/createjs-utilities";
import { antiCheating } from "../../antiCheating/AntiCheating";
